import * as React from 'react';
import { Query } from 'react-apollo';

import { tupleToStringKey } from 'js/lib/stringKeyTuple';
import user from 'js/lib/user';

import type { SkippableNextStep } from 'bundles/course-home/page-course-week/components/next-step-card/constants';
import { courseNextStepQuery } from 'bundles/course-v2/queries/queries';
import type {
  GuidedCourseNextStepsV1,
  GuidedCourseNextStepsV1MultiGetQuery,
  GuidedCourseNextStepsV1MultiGetQueryVariables,
} from 'bundles/naptimejs/resources/__generated__/GuidedCourseNextStepsV1';

type Props = {
  courseSlug: string;
  stepsToSkip: SkippableNextStep[];
  children: (args: {
    courseNextStep?: GuidedCourseNextStepsV1;
    error?: Error;
    loading: boolean;
  }) => React.ReactElement | null;
};

const CourseNextStepProvider: React.FC<Props> = ({ children, courseSlug, stepsToSkip }) => (
  <Query<GuidedCourseNextStepsV1MultiGetQuery, GuidedCourseNextStepsV1MultiGetQueryVariables>
    query={courseNextStepQuery}
    variables={{ ids: tupleToStringKey([user.get().id, courseSlug]), stepsToSkip: stepsToSkip.join(',') }}
    fetchPolicy="cache-and-network"
  >
    {({ data, error, loading }) =>
      children({
        courseNextStep: data?.GuidedCourseNextStepsV1?.multiGet?.elements?.[0],
        error,
        loading,
      })
    }
  </Query>
);

export default CourseNextStepProvider;
